module.exports = __webpack_public_path__ + "img/MEDIA067.68fa04c1.jpg";